import AxiosService from './axios.service';
import { AxiosResponse } from 'axios';
import { CompletarModuloResponse, CreateModuloDto, Modulo, UpdateModuloDto } from './types/cursos.types';

export class ModulosService {
  static async create(cursoId: string, dto: CreateModuloDto): Promise<Modulo> {
    const response: AxiosResponse<Modulo> = await AxiosService.post(`/cursos/${cursoId}/modulos`, dto);
    return response.data;
  }

  static async findAllByCurso(cursoId: string): Promise<Modulo[]> {
    const response: AxiosResponse<Modulo[]> = await AxiosService.get(`/cursos/${cursoId}/modulos`);
    return response.data;
  }

  static async findOne(id: string): Promise<Modulo> {
    const response: AxiosResponse<Modulo> = await AxiosService.get(`/cursos/modulos/${id}`);
    return response.data;
  }

  static async update(id: string, dto: UpdateModuloDto): Promise<Modulo> {
    const response: AxiosResponse<Modulo> = await AxiosService.patch(`/cursos/modulos/${id}`, dto);
    return response.data;
  }

  static async remove(id: string): Promise<void> {
    await AxiosService.delete(`/cursos/modulos/${id}`);
  }

  static async completar(id: string): Promise<CompletarModuloResponse> {
    const response: AxiosResponse<CompletarModuloResponse> = await AxiosService.post(`/cursos/modulos/${id}/completar`, {});
    return response.data;
  }
}
